'use client';

import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';

type DataDogRumInitializerProps = {
  hasUserConsent: boolean;
  isInternalUser: boolean;
};

export function DatadogRumInitializer({
  hasUserConsent = false,
  isInternalUser = false
}: DataDogRumInitializerProps) {
  const isInitializedRef = useRef(false);
  const { environment } = useRequestContext();

  useEffect(() => {
    if (isInternalUser) return;
    if (!hasUserConsent) return;
    if (isInitializedRef.current) return;
    if (environment !== 'production') return;

    datadogRum.init({
      applicationId: '4522792d-79d4-4b9f-b91a-c089a1b26f65',
      clientToken: 'pub76f21b829ffc9b541446363034830cfd',
      site: 'datadoghq.eu',
      service: 'coolblue-microfrontend',
      env: 'production',
      // We should definitely decrease the sample rate once we go
      // live with more pre-cart page microfrontend pages
      sessionSampleRate: 1,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: 'mask-user-input'
    });

    isInitializedRef.current = true;
  }, [hasUserConsent, isInternalUser, environment]);

  return null;
}
